import { useEffect, useState } from 'react';

// Re-renders once a second while enabled. Returns Date.now(), or 0 before the
// first tick — clock reads stay inside the interval so render stays pure.
export const useSecondTick = (enabled: boolean): number => {
  const [now, setNow] = useState(0);
  useEffect(() => {
    if (!enabled) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [enabled]);
  return now;
};
